import React, {useEffect, useState} from "react";
import Navbar from "../../../../common/layout/Navbar";
import {Title} from "../../../../../stories/Title/Title";
import Input from "../../../../../stories/Input/Input";
import {TextField} from "@mui/material";
import {LicenseTypes} from "../../../../../utils/Enum.types";
import {Button} from "../../../../../stories/Button/Button";
import {useNavigate} from "react-router-dom";
import {useLazyQuery} from "@apollo/client";
import {GetProjectsTableHeaderCount} from "../../masters/projects/queries/queries";
import {
  GetProjectsTableHeaderCountResult,
  GetProjectsTableHeaderCountVar,
} from "../../masters/projects/queries/types";
import useUrlParams from "../../../../../customHooks/useUrlParams";
import useLoggedInUserDetails from "../../../../../customHooks/useLoggedInUserDetails";
import WorkProgressItem, {
  projects,
  WorkProgressPageFor,
} from "./WorkProgressItem";
import {EMPTY_STRING} from "../../../../../utils/constants";

const TableStructure = () => {
  const navigate = useNavigate();

  const {customer_id} = useUrlParams();
  const {user_details} = useLoggedInUserDetails();

  const [searchProject, setSearchProject] = useState("");

  const [GetProjects, {data}] = useLazyQuery<
    GetProjectsTableHeaderCountResult,
    GetProjectsTableHeaderCountVar
  >(GetProjectsTableHeaderCount);

  useEffect(() => {
    if (customer_id)
      GetProjects({
        variables: {
          customerID: customer_id,
          empID: user_details.id,
          toAddHeaders:true
        },
      });
  }, [customer_id, user_details.id, GetProjects]);

  return (
    <>
      <Navbar NavType={LicenseTypes.DASHBOARD} />
      <Title>Work Progress</Title>
      <div className="work-progress">
        <div className="work-progress__row row g-0">
          <div className="col-2">
            <Input
              id="data_search"
              placeholder="Search..."
              onChange={(e) => setSearchProject(e.target.value)}
            />
          </div>
          <div className="col"></div>
          {/* <div className="col-2 flex-end">
            <TextField
              type="date"
              slotProps={{
                inputLabel: {
                  shrink: true,
                },
              }}
              label="Date"
              className="work-progress__row--text-field"
            />
          </div> */}
        </div>
        {data ? (
          <div className="work-progress__block">
            <div className="work-progress__block--grids">
              {data.GetProjectsTableHeaderCount.filter(
                (res) =>
                  res.projectDetails.name
                    .toLocaleLowerCase()
                    .includes(searchProject.toLocaleLowerCase()) ||
                  searchProject === EMPTY_STRING
              ).map((res, index) => {
                return (
                  <WorkProgressItem
                    res={res}
                    index={index}
                    pageType={WorkProgressPageFor.GENERAL}
                    key={index}
                  />
                );
              })}
            </div>
          </div>
        ) : null}
        <Button mode="back" onClick={() => navigate(-1)} />
      </div>
    </>
  );
};

export default TableStructure;
